export default "__VITE_ASSET__406cb607__"